import { render, staticRenderFns } from "./ItemDetailOpenMarketLayout.vue?vue&type=template&id=c59c79aa&scoped=true"
import script from "./ItemDetailOpenMarketLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailOpenMarketLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59c79aa",
  null
  
)

export default component.exports